import { useSelector } from 'react-redux';
import core from '@gin-betting/core';

import { State } from 'types';

const {
    viewport: {
        selectors: { makeViewportSelector },
    },
} = core;

interface Output {
    isCompact: boolean;
}

const useSearch = (): Output => {
    const selectProps = makeViewportSelector('lessThanOrEqual', 'medium');

    const isCompact = useSelector<State, ReturnType<typeof selectProps>>(
        state => selectProps(state, {})
    );

    return {
        isCompact,
    };
};

export default useSearch;
